import React, { useContext } from 'react';
import { Oval } from 'react-loader-spinner';
import { LoadingContext } from '../../contexts/LoadingContext';
import styles from './LoadingOverlay.module.scss';

const LoadingOverlay: React.FC = () => {
  const { isLoading } = useContext(LoadingContext);

  if (!isLoading) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.spinner}>
        <Oval color="#ffffff" height={40} width={40} />
      </div>
    </div>
  );
};

export default LoadingOverlay;